<script setup lang="ts">
import { useTheme } from "vuetify";
import ScrollToTop from "@core/components/ScrollToTop.vue";
import initCore from "@core/initCore";
import { initConfigStore, useConfigStore } from "@core/stores/config";
import { hexToRgb } from "@core/utils/colorConverter";
import { userStore } from "@/store/user";
import { onMounted } from "vue";
import TrialFooter from "@/components/TrialFooter.vue";
import { useRoute } from "vue-router";

const { global } = useTheme();

// ℹ️ Sync current theme with initial loader theme
initCore();
initConfigStore();

const configStore = useConfigStore();
const user = userStore();
const route = useRoute();

// Inicializa o estado do usuário
onMounted(async () => {
  // Não inicializa o usuário em rotas públicas para evitar redirecionamentos indesejados
  if (route.meta.requireAuth !== false) {
    await user.initializeApp();
    await user.checkFirstAccess();
  }
});
</script>

<template>
  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp
      :style="`--v-global-theme-primary: ${hexToRgb(
        global.current.value.colors.primary
      )}`"
    >
      <ToastNotifications />
      <RouterView />
      <TrialFooter />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
